"use strict";
import Api from "../../api/api";
import Address from "./address";
import CarrierService from "../../services/carrier_service";
import CustomerLoadsInformation from "./customer_loads_information";
import DropInformation from "./drop_information";
import generalFormatter from "../../formatters/general";
import get from "../data/get";
import HoverableValueTable from "../hoverable_value_table";
import { allReferences } from "../../helpers/references";
import ReactUtils from "../../react_utils";
import _ from "underscore";
import ValueTableItem from "./value_table_item";
import LoadLineItems, {
  LINE_ITEM_MODE__CARRIER,
  LINE_ITEM_MODE__SHIPMENTS,
  LINE_ITEM_MODE__SIDE_BY_SIDE
} from "./load_line_items";
import React from "react";
const bem = ReactUtils.makeBem("load-detail");
function renderBlindShipmentIcon() {
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("i", { className: `shipment-approval__flags__icon fi-check green` }), "\xA0TRUE");
}
function shippedItemDisplay(shippedItem, index) {
  return /* @__PURE__ */ React.createElement("tr", { key: "load_detail_data_row_" + index }, /* @__PURE__ */ React.createElement("td", null, shippedItem.description), /* @__PURE__ */ React.createElement("td", null, shippedItem.weight, " ", shippedItem.weight_unit), /* @__PURE__ */ React.createElement("td", null, shippedItem.class_name), /* @__PURE__ */ React.createElement("td", null, shippedItem.quantity), /* @__PURE__ */ React.createElement("td", null, shippedItem.item_type), /* @__PURE__ */ React.createElement("td", null, shippedItem.length), /* @__PURE__ */ React.createElement("td", null, shippedItem.width), /* @__PURE__ */ React.createElement("td", null, shippedItem.height), /* @__PURE__ */ React.createElement("td", null, shippedItem.nmfc));
}
function noteDisplay(notes, note_type) {
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("strong", null, note_type, ":"), "\xA0", notes.reduce((prev, curr) => [prev, /* @__PURE__ */ React.createElement("br", null), curr]));
}
function valueTable(pairs, labelToolTipText) {
  var names = pairs.map((pair) => pair[0]);
  var values = pairs.map((pair) => pair[1]);
  var width = 100 / names.length + "%";
  return /* @__PURE__ */ React.createElement("table", { className: "load-detail__info-table" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: "load-detail__info-table-header" }, _.map(names, function(name) {
    if (labelToolTipText) {
      return /* @__PURE__ */ React.createElement(
        "th",
        {
          "data-tooltip": true,
          "aria-haspopup": "true",
          title: labelToolTipText,
          style: { width },
          key: name
        },
        name
      );
    } else {
      return /* @__PURE__ */ React.createElement("th", { "style-": { width }, key: name }, name);
    }
  }))), /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", { className: "load-detail__info-table-data" }, _.map(values, function(value, index) {
    return /* @__PURE__ */ React.createElement("td", { key: "load_detail_info_value" + index }, value);
  }))));
}
function sideBySideLineItemsUxImprovementsEnabled() {
  return Api.Account.currentSettings().side_by_side_line_items_ux_improvements_enabled;
}
function carrierReferences(carrier) {
  const settings = Api.Account.currentSettings() || {};
  const reference_fields = settings.tms_carrier_visible_reference_fields || [];
  return _.map(reference_fields, function(field) {
    const value = carrier.references[field];
    return {
      name: field,
      value: value ? value : "-"
    };
  });
}
function carrierTable(carrierName, carrierReferences2) {
  if (carrierName) {
    const displayValues = [{ name: "Name", value: carrierName }].concat(
      carrierReferences2
    );
    const rows = _.map(displayValues, function(value) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: bem("__info-reference-pair"),
          key: `shipment-reference-${value.name}`
        },
        /* @__PURE__ */ React.createElement("span", { className: bem("__info-reference-name") }, value.name, ":"),
        /* @__PURE__ */ React.createElement("span", { className: bem("__info-reference-value") }, value.value)
      );
    });
    return /* @__PURE__ */ React.createElement("table", { className: bem("__info-table", "__info-table-with-references") }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: bem("__info-table-header") }, /* @__PURE__ */ React.createElement("th", null, "TMS Carrier"))), /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { className: bem("__info-with-references") }, rows))));
  } else {
    return null;
  }
}
var LoadDetailInformation = React.createClass({
  getInitialState: function() {
    return {
      lineItemsLoaded: false,
      lineItems: [],
      lineItemCarriers: [],
      shipments: []
    };
  },
  componentWillMount: function() {
    this.loadLineItems(this.props);
  },
  componentWillReceiveProps: function(nextProps) {
    if (this.props.load.id != nextProps.load.id) {
      this.setState(this.getInitialState());
      this.loadLineItems(nextProps);
    }
  },
  render: function() {
    const isSideBySideLineItemsUxImprovementsEnabled = sideBySideLineItemsUxImprovementsEnabled();
    return /* @__PURE__ */ React.createElement("div", { "data-component": "LoadDetailInformation" }, /* @__PURE__ */ React.createElement("h3", { className: "load-detail__section-header load-detail__section-header__load-info" }, "Load Information"), this.renderLineItems(
      LINE_ITEM_MODE__SIDE_BY_SIDE,
      isSideBySideLineItemsUxImprovementsEnabled
    ), this.addressInformation(), this.possibleDropInformation(), this.possibleCustomerLoadInformation(), this.referenceInformation(), this.possibleMemo(), this.possibleNotesFromLoad(), this.carrierInformation(), this.renderLineItems(
      LINE_ITEM_MODE__CARRIER,
      !isSideBySideLineItemsUxImprovementsEnabled
    ), this.renderLineItems(
      LINE_ITEM_MODE__SHIPMENTS,
      !isSideBySideLineItemsUxImprovementsEnabled
    ), this.shippedItems());
  },
  renderLineItems(mode, condition) {
    if (condition) {
      return /* @__PURE__ */ React.createElement(
        LoadLineItems,
        {
          mode,
          load: this.props.load,
          invoice: this.props.invoice,
          lineItems: this.state.lineItems,
          lineItemsLoaded: this.state.lineItemsLoaded,
          lineItemCarriers: this.state.lineItemCarriers,
          shipments: this.state.shipments
        }
      );
    } else {
      return /* @__PURE__ */ React.createElement("div", null);
    }
  },
  renderDistance: function(distance) {
    return /* @__PURE__ */ React.createElement(
      ValueTableItem,
      {
        onValueHighlighted: this.props.onTextToHighlightChanged,
        onValueClick: this.props.advanceableTextClicked,
        value: distance
      }
    );
  },
  shippedItems: function() {
    const shippedItems = this.props.load.load.shipped_items;
    if (shippedItems.length > 0) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("div", { key: "shipped-items", className: "load-detail__shipped-items" }, /* @__PURE__ */ React.createElement("div", { className: "load-detail__shipped-item-table-title" }, /* @__PURE__ */ React.createElement("h4", { className: "load-detail__shipped-item-header" }, "Shipped Items")), /* @__PURE__ */ React.createElement("table", { className: "load-detail__info-table", key: "shipped-items" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: "load-detail__info-table-header" }, /* @__PURE__ */ React.createElement("th", null, "Desc"), /* @__PURE__ */ React.createElement("th", null, "Wt"), /* @__PURE__ */ React.createElement("th", null, "Class name"), /* @__PURE__ */ React.createElement("th", null, "Qty"), /* @__PURE__ */ React.createElement("th", null, "Item type"), /* @__PURE__ */ React.createElement("th", null, "L"), /* @__PURE__ */ React.createElement("th", null, "W"), /* @__PURE__ */ React.createElement("th", null, "H"), /* @__PURE__ */ React.createElement("th", null, "NMFC"))), /* @__PURE__ */ React.createElement("tbody", null, _.map(shippedItems, (si, index) => {
        return shippedItemDisplay(si, index);
      }))))));
    }
  },
  showFullNote: function(note_type) {
    return this.state[note_type];
  },
  toggleShowFullNote: function(note_type) {
    const state = this.state;
    state[note_type] = !this.showFullNote(note_type);
    this.setState(state);
  },
  toggleFullNoteDisplay: function(note_type) {
    const text = this.showFullNote(note_type) ? "show less" : "show more";
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("a", { onClick: () => this.toggleShowFullNote(note_type) }, text));
  },
  possibleNoteDisplay: function(note, note_type) {
    const notes = note.split("\n");
    if (notes.length > 4) {
      if (!this.showFullNote(note_type)) {
        notes.splice(4);
      }
      return /* @__PURE__ */ React.createElement("div", null, noteDisplay(notes, note_type), this.toggleFullNoteDisplay(note_type));
    }
    return /* @__PURE__ */ React.createElement("div", null, noteDisplay(notes, note_type));
  },
  possibleLoadNoteDisplay: function(load) {
    if (load.data.load_note) {
      return this.possibleNoteDisplay(load.data.load_note, "Load Note");
    }
  },
  possibleSpecialInstructionsDisplay: function(load) {
    if (load.data.special_instructions) {
      return this.possibleNoteDisplay(
        load.data.special_instructions,
        "Special Instructions"
      );
    }
  },
  possiblePayablesNoteDisplay: function(load) {
    if (load.data.payables_note) {
      return this.possibleNoteDisplay(load.data.payables_note, "Payables Note");
    }
  },
  notesDisplay: function(load) {
    return /* @__PURE__ */ React.createElement("div", null, this.possibleLoadNoteDisplay(load), this.possibleSpecialInstructionsDisplay(load), this.possiblePayablesNoteDisplay(load));
  },
  possibleNotesFromLoad: function() {
    const load = this.props.load.load;
    if (load.data.load_note || load.data.special_instructions || load.data.payables_note) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, valueTable([["Notes From Load", this.notesDisplay(load)]]));
    }
  },
  address: function(source, prefix) {
    return /* @__PURE__ */ React.createElement(
      Address,
      {
        onValueHighlighted: this.props.onTextToHighlightChanged,
        onValueClick: this.props.advanceableTextClicked,
        source,
        prefix
      }
    );
  },
  loadLineItems: function(props) {
    const lineItems = props.load.load.line_items;
    const carrierIds = _.chain([
      lineItems,
      props.load.load.tms_carrier_payables
    ]).compact().flatten().pluck("tms_carrier_id").compact().unique().value();
    var carriers = _.map(carrierIds, (carrierId) => {
      return get.carrierById(carrierId);
    });
    const shipments = get.tmsShipments(props.load.load) || [];
    Promise.all(carriers).then((values) => {
      this.setState({
        lineItemsLoaded: true,
        lineItemCarriers: values,
        lineItems,
        shipments
      });
    });
  },
  addressInformation: function() {
    if (!Api.Account.currentSettings().prefer_shipment_location_data) {
      var load = this.props.load.load;
      var origin = this.address(load, "origin_");
      var destination = this.address(load, "destination_");
      var elements = [
        ["Origin", origin],
        ["Destination", destination]
      ];
      if (load.distance)
        elements.push(["Distance", this.renderDistance(load.distance)]);
      if (load.data.blind)
        elements.push(["Blind Shipment", renderBlindShipmentIcon()]);
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, valueTable(elements)));
    }
  },
  referenceInformation: function() {
    const load = this.props.load.load;
    const references = allReferences(load);
    return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
      HoverableValueTable,
      {
        items: references,
        onValueHighlighted: this.props.onTextToHighlightChanged,
        onValueClick: this.props.advanceableTextClicked
      }
    )));
  },
  possibleMemo: function() {
    var memo = this.props.load.load.memo;
    if (memo) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, valueTable([["Memo", memo]])));
    }
  },
  carrierInformation: function() {
    if (!Api.Account.currentSettings().prefer_shipment_location_data) {
      var load = this.props.load.load;
      var shipped = load.actual_shipped_at ? generalFormatter.date(load.actual_shipped_at) : void 0;
      var delivered = load.actual_delivered_at ? generalFormatter.date(load.actual_delivered_at) : void 0;
      var carrierName = null;
      var carrierNotes = null;
      var references = [];
      if (load.carrier_id) {
        var carrier = CarrierService.getCarrierOrUnknown(load.carrier_id);
        carrierName = carrier.name;
        var customer_charge = load.customer_charge ? generalFormatter.currency(load.customer_charge) : void 0;
        carrierNotes = carrier.notes ? /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, valueTable([["Carrier Notes", carrier.notes]])) : "";
        references = carrierReferences(carrier);
      }
      return /* @__PURE__ */ React.createElement("div", { className: "row load-detail__load-info-area" }, /* @__PURE__ */ React.createElement("div", { className: "small-3 column load-detail__row-table-container-start" }, shipped ? valueTable([["Ship Date", shipped]]) : valueTable([["Ship Date", "-"]])), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "small-3 column load-detail__row-table-container" + (customer_charge ? "" : "-end")
        },
        delivered ? valueTable([["Delivered Date", delivered]]) : valueTable([["Delivered Date", "-"]])
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "small-4 column load-detail__row-table-container" + (customer_charge ? "-end" : "")
        },
        customer_charge ? valueTable([["Customer Charge", customer_charge]]) : ""
      ), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, carrierTable(carrierName, references)), carrierNotes);
    }
  },
  possibleDropInformation: function() {
    var drops = get.tmsDrops(this.props.load.load);
    var deliveries = get.tmsDropDeliveries(this.props.load.load);
    if (drops.length > 0 && deliveries.length > 0) {
      return /* @__PURE__ */ React.createElement(
        DropInformation,
        {
          load: this.props.load.load,
          onValueHighlighted: this.props.onTextToHighlightChanged,
          onValueClick: this.props.advanceableTextClicked
        }
      );
    }
  },
  possibleCustomerLoadInformation: function() {
    const customerLoads = get.tmsCustomerLoads(this.props.load.load);
    if (customerLoads.length > 0) {
      return /* @__PURE__ */ React.createElement(CustomerLoadsInformation, { customerLoads });
    }
  }
});
export default LoadDetailInformation;
